module.exports = __webpack_public_path__ + "img/tree.1bcfdf48.png";